export default __webpack_public_path__ + "static/media/B730F207-1037-4279-8118-C9BB0AFC25BB_1_102_o.4c102342.jpeg";